<main class="landing-shell" lang="ckb" dir="rtl">
  <section class="hero-card">
    <img class="brand-logo" src="/asan_logo.jpeg" alt="Asan Jobs Office logo" />
    <p class="kicker">ئاسانی ئۆفیسی کار</p>
    <h1>بە خێرایی زیاتر پەیوەندی بە خاوەنکارەکان بکە</h1>
    <p class="lead">
      ئێمە یارمەتی داواکەرانی کار دەدەین لە سلێمانی هەلی کار لەگەڵ کۆمپانیا باوەڕپێکراوەکان بدۆزنەوە.
      تەنها جارێک سیڤییەکەت پڕ بکەوە و بێڵە ئۆفیسەکان پەیوەندیت پێوە بکەن.
    </p>

    <div class="hero-actions">
      <a class="cta-primary" routerLink="/fill-cv">پڕکردنەوەی سیڤی</a>
      <a class="cta-secondary" href="tel:009647705059539">پەیوەندی بکە</a>
    </div>

    <div class="social-grid" aria-label="Social media links">
      @for (link of socialLinks; track link.href) {
        <a
          [href]="link.href"
          target="_blank"
          rel="noopener noreferrer"
          class="social-item"
          [attr.aria-label]="link.label"
          [attr.title]="link.label"
        >
          <span class="icon-wrap" aria-hidden="true">
            @if (link.icon === 'facebook') {
              <svg viewBox="0 0 24 24" fill="none"><path d="M13.5 22V12.9H16.5L17 9.5H13.5V7.4C13.5 6.5 13.8 5.9 15.1 5.9H17.1V2.9C16.7 2.8 15.8 2.7 14.7 2.7C12.3 2.7 10.7 4.2 10.7 6.9V9.5H8V12.9H10.7V22H13.5Z" fill="currentColor"/></svg>
            }
            @if (link.icon === 'instagram') {
              <svg viewBox="0 0 24 24" fill="none"><path d="M7.5 3H16.5C19 3 21 5 21 7.5V16.5C21 19 19 21 16.5 21H7.5C5 21 3 19 3 16.5V7.5C3 5 5 3 7.5 3ZM12 8C9.8 8 8 9.8 8 12C8 14.2 9.8 16 12 16C14.2 16 16 14.2 16 12C16 9.8 14.2 8 12 8ZM17 6.5C16.4 6.5 16 6.9 16 7.5C16 8.1 16.4 8.5 17 8.5C17.6 8.5 18 8.1 18 7.5C18 6.9 17.6 6.5 17 6.5Z" fill="currentColor"/></svg>
            }
            @if (link.icon === 'tiktok') {
              <svg viewBox="0 0 24 24" fill="none"><path d="M14.5 3C14.8 4.9 16.1 6.4 18 6.9V9.5C16.7 9.4 15.5 8.9 14.5 8V14.2C14.5 17.3 12 19.8 8.9 19.8C5.8 19.8 3.3 17.3 3.3 14.2C3.3 11.1 5.8 8.6 8.9 8.6C9.2 8.6 9.5 8.6 9.8 8.7V11.6C9.5 11.5 9.2 11.5 8.9 11.5C7.4 11.5 6.2 12.7 6.2 14.2C6.2 15.7 7.4 16.9 8.9 16.9C10.4 16.9 11.6 15.7 11.6 14.2V3H14.5Z" fill="currentColor"/></svg>
            }
          </span>
        </a>
      }
    </div>

    <div class="phone-list" aria-label="Phone numbers">
      @for (phone of phones; track phone) {
        <a [href]="'tel:' + phone" class="phone-item">
          <svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6.8 10.9C8.2 13.7 10.4 15.9 13.2 17.2L15.4 15C15.7 14.7 16.1 14.6 16.5 14.7C17.6 15 18.8 15.2 20 15.2C20.6 15.2 21 15.6 21 16.2V20C21 20.6 20.6 21 20 21C10.1 21 3 13.9 3 4C3 3.4 3.4 3 4 3H7.8C8.4 3 8.8 3.4 8.8 4C8.8 5.2 9 6.4 9.3 7.5C9.4 7.9 9.3 8.3 9 8.6L6.8 10.9Z" fill="currentColor"/></svg>
          <span>{{ phone }}</span>
        </a>
      }
    </div>
  </section>
</main>
